import { render, staticRenderFns } from "./bottom-panel.vue?vue&type=template&id=32a3009a&scoped=true"
import script from "./bottom-panel.vue?vue&type=script&lang=js"
export * from "./bottom-panel.vue?vue&type=script&lang=js"
import style0 from "./bottom-panel.vue?vue&type=style&index=0&id=32a3009a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3009a",
  null
  
)

export default component.exports